module.exports = __webpack_public_path__ + "img/image35-5sc.9a3777c6.png";